import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetSalaryorGrade(id) {
  return useQuery(
    ['range-or-grade_in_organisition', id],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.COMPANY_DETAILS, {
          company_id: id,
        })
      );

      return response.data;
    },
    {
      enabled: !!id,
    }
  );
}
